// Background.js
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const Background = () => {
    const location = useLocation();

    useEffect(() => {
        // Change the background color based on the route
        if (location.pathname === '/service') {
            document.body.style.backgroundColor = '#ebebeb';
        } else {
            document.body.style.backgroundColor = 'white'; // or whatever your default color is
        }
    }, [location.pathname]);

    return null; // This component does not render anything itself
};

export default Background;
